export default __webpack_public_path__ + "images/assets/82de4cb8163cb5104a68944469e1baf9.svg";